/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{ref:"marker",staticClass:"marker markerPin",attrs:{"color":_vm.color,"size":"30"},on:{"mousedown":_vm.onDragStart}},[_vm._v("\n  fal fa-map-pin\n")])}
var staticRenderFns = []

export { render, staticRenderFns }